@if(service.viewDroplistItems.length){
<div class='delivery-engagements-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.ContactReqs) {
	<delivery-contact-request-view-part></delivery-contact-request-view-part>
	}
	@case (service.viewId.OpenEngagements) {
	<delivery-open-engagements-view-part></delivery-open-engagements-view-part>
	}
	@case (service.viewId.CompletedEngagements) {
	<delivery-completed-engagements-view-part></delivery-completed-engagements-view-part>
	}
	@case (service.viewId.FollowUps) {
	<delivery-follow-ups-view-part></delivery-follow-ups-view-part>
	}
	}
	}

</div>
}